import React from 'react';
import { CallToActionButton } from './CallToActionButton';

export const HeroContent = () => {

  const handleScrollToPlans = () => {
    const el = document.getElementById("nossos-planos");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };


  const titleStyles = {
    fontSize: '2rem',
    fontWeight: 'bold',
    lineHeight: '70px',
    color: '#212529',
    letterSpacing: '7.75px',
    marginBottom: '0.5rem',
    textAlign: 'center'

  };

  const mobileStyles = `
    @media (max-width: 576px) {
      .hero-title {
        line-height: normal !important;
        white-space: nowrap !important;
        font-size: 1.1rem !important;
      }
      .hero-description {
        font-size: 0.9rem !important;
      }
      .hero-link {
        font-size: 0.875rem !important;
      }
    }
  `;

  return (
    <>
      <style>{mobileStyles}</style>
      <div className="text-center">
        <header className="mb-3">
          <h1 className="hero-title" style={titleStyles}>
            TODA VIDA IMPORTA!
          </h1>
        </header>

        <section className="mx-auto mb-5" style={{ maxWidth: '707px' }}>
          <p className="hero-description text-center text-muted">
            Acesso a consultas, exames, telemedicina Einstein (24h), descontos
            em medicamentos, bem-estar e muito mais. Tudo por um valor que cabe
            no seu bolso.
          </p>
        </section>

        <nav className="d-flex flex-column align-items-center gap-3">
          <CallToActionButton variant="primary" onClick={handleScrollToPlans}>
            <span className="fw-bold text-white">
              Contratar agora
            </span>
          </CallToActionButton>

          <a
            href="#nossos-planos"
            className="hero-link text-decoration-underline"
            style={{ color: '#0c4a6e' }}
          >
            Quero conhecer os planos
          </a>
        </nav>
      </div>
    </>
  );
};
